import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { Container, Flex, Center, Text, useBreakpointValue, useToast, Spinner } from "@chakra-ui/react";

import { DURATION_TOAST } from "@/common/constants";
import { sendOAuthRequest } from "@/services/authService";

const Unauthenticated: React.FC = () => {
    const navigate = useNavigate();
    const isWideScreen = useBreakpointValue({ base: false, md: true });
    const toast = useToast();

    const showToast = (title: string, description: string, status: 'success' | 'error') => {
        toast({
            title,
            description,
            status,
            duration: DURATION_TOAST,
            isClosable: true,
        });
    };

    const redirectToLogin = async () => {
        try {
            const response = await sendOAuthRequest();
            if (response?.error) {
                showToast('Error Auth', response.message, 'error');
            }
        } catch (error) {
            showToast('Error Auth', 'Error during sign-in redirect: ' + error, 'error');
        }
    };

    useEffect(() => {
        redirectToLogin();
    }, [navigate]);

    return (
        <Container maxW="100%" minH="100vh" p={0}>
            <Flex
                direction={isWideScreen ? 'row' : 'column'}
                align="center"
                justify="center"
            >
                <Flex
                    direction="column"
                    align="center"
                    justify="center"
                    p={8}
                    w={isWideScreen ? '50%' : '100%'}
                    h={isWideScreen ? '90vh' : 'auto'}
                >
                    <Center flexDirection="column" textAlign="center">
                        <Spinner size="xl" />
                        <Text mt={4}>Redirecting to login ...</Text>
                    </Center>
                </Flex>
            </Flex>
        </Container>
    );
};

export default Unauthenticated;
